import React, { useRef } from "react";

import InputNumber from "@app/components/2_widgets/inputs/InputNumber";
import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";

import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';

export default function InputSiren({callback, buttonLabel, label=null}) {
    const refSiren = useRef();
    const auth = useAuth();

    function searchSiren(event) {
        event.preventDefault();

        const siren = refSiren.current.getValue();

        apiCall({
            method: "get",
            path: `/api/v1/customers/show_siren?siren=${siren}`,
            auth: auth,
            onSuccess: (response) => {                
                if (callback)
                    callback(response.data.customer);  
            }
        });
    }
    
    return (
        <div className="row align-items-center">
            <div className="col-10">
                <InputNumber
                    ref={refSiren}
                    inputId="text-input"
                    label={label}                    
                    placeholder="Entrez le SIREN (9 chiffres)"
                />
            </div>
            <div className={`col-2 mb-3 ${label ? "pt-4" : ""}`}>
                <ButtonPrimary label={buttonLabel ? buttonLabel : "Créer"} onClick={searchSiren}/>
            </div>                
        </div>        
    )    
}